mutation deleteLeads($input: DeleteLeadsInput!) {
  deleteLeads(input: $input)
}
